import { fromUnixTimestamp } from '@/util/UnixTimestamps';

export default {
    methods: {
        $du(date, format) {
            let d = date;
            if (Number.isInteger(date)) {
                d = new Date(fromUnixTimestamp(date));
            }
            return this.$d(d, format);
        },
    },
};
